import { Button, Dialog, Portal } from '@chakra-ui/react';
import fonts from 'src/theme/fonts';
import { useCacheBusterContext } from './CacheBusterContext';

export default function CachePopup() {
  const cacheBuster = useCacheBusterContext();

  return (
    <Dialog.Root
      closeOnInteractOutside={false}
      preventScroll={false}
      modal={false}
      placement="bottom"
      open={cacheBuster.open}
      size="xs"
    >
      <Portal>
        <Dialog.Positioner pointerEvents="none" justifyContent="flex-end">
          <Dialog.Content
            marginInline="4rem"
            borderColor="podcastShade300"
            borderWidth="1px"
            p="8px"
          >
            <Dialog.Body>
              <p>
                <b>A new version of Alitu is available.</b> Would you like to update?
              </p>
            </Dialog.Body>
            <Dialog.Footer>
              <Button fontFamily={fonts.bold} onClick={cacheBuster.refresh} w="100%">
                Update
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
}
